<template>
  <!-- Same result layout as PaymentSelection's card / PayNow result
       (.ksk-pay in kiosk-theme2.css): icon → title → caption. -->
  <div class="ksk-pay">
    <div class="ksk-pay__icon">
      <span class="material-icons-round">{{ icon }}</span>
    </div>
    <div class="ksk-pay__title">{{ title }}</div>
    <div v-if="message" class="ksk-pay__caption">{{ message }}</div>
  </div>
</template>

<script>
export default {
  name: "PaymentErrorScreen",
  props: {
    title: {
      type: String,
      default: "Payment failed",
    },
    message: {
      type: String,
      default: "",
    },
    // Material icon in the red disc (e.g. "timer_off" for a time out).
    icon: {
      type: String,
      default: "close",
    },
  },
};
</script>
